import React from "react";
import PropTypes from "prop-types";
import { Input } from "antd";

const AddressForm = ({
  addressLine1,
  setAddressLine1,
  unitNumber,
  setUnitNumber,
  addressLine2,
  setAddressLine2,
  city,
  setCity,
  province,
  setProvince,
  postalCode,
  setPostalCode,
  country,
  setCountry,
}) => (
  <div className="address-form">
    <h3 className="header">ADDRESS</h3>
    <div className="address-form-row">
      <Input
        className="address-line-1"
        onChange={(e) => setAddressLine1(e.target.value)}
        placeholder="Address Line 1"
        value={addressLine1}
      />
      <Input
        className="unit-number"
        onChange={(e) => setUnitNumber(e.target.value)}
        placeholder="Unit #"
        value={unitNumber}
      />
    </div>
    <div className="address-form-row">
      <Input onChange={(e) => setAddressLine2(e.target.value)} placeholder="Address Line 2" value={addressLine2} />
    </div>

    <div className="address-form-row">
      <Input className="city" onChange={(e) => setCity(e.target.value)} placeholder="City" value={city} />

      <Input
        className="province"
        onChange={(e) => setProvince(e.target.value)}
        placeholder="Province"
        value={province}
      />

      <Input
        className="postal-code"
        onChange={(e) => setPostalCode(e.target.value)}
        placeholder="Postal Code"
        value={postalCode}
      />
    </div>

    <div className="address-form-row">
      <Input className="country" onChange={(e) => setCountry(e.target.value)} placeholder="Country" value={country} />
    </div>
  </div>
);

AddressForm.propTypes = {
  addressLine1: PropTypes.string.isRequired,
  unitNumber: PropTypes.string.isRequired,
  addressLine2: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  province: PropTypes.string.isRequired,
  postalCode: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  setAddressLine1: PropTypes.func.isRequired,
  setUnitNumber: PropTypes.func.isRequired,
  setAddressLine2: PropTypes.func.isRequired,
  setCity: PropTypes.func.isRequired,
  setProvince: PropTypes.func.isRequired,
  setPostalCode: PropTypes.func.isRequired,
  setCountry: PropTypes.func.isRequired,
};

export default AddressForm;
